export default {
  'customNotifications.title': 'Custom Notifications',
  'notification.status.Pending': 'Pending',
  'notification.status.Finished': 'Finished',
  'notification.status.Rejected': 'Rejected',
  'notification.status.Overdue': 'Overdue',
  'notification.status.Skipped': 'Skipped',
  'notification.status.Error': 'Error',
  'notification.status.Execution': 'Execution',
  'notification.addedUsers': 'Added Users',
  'customNotifications.form.isSendToApplicantEnabled': '¿Send to Applicant?',
  'customNotifications.form.form': 'Form',
  'customNotifications.form.field': 'Field',
};
